import React from 'react';
import { FileText, Users } from 'lucide-react';

const HomeScreen = ({ onNewAssessment, onViewCases }) => {
  return (
    <div className="h-[calc(100vh-4rem)] bg-gradient-to-br from-teal-50 to-blue-50 flex items-center justify-center px-6 py-4 overflow-y-auto">
      <div className="max-w-4xl w-full">
        <div className="text-center mb-8">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Welcome to Clinical Docs</h2>
          <p className="text-xl text-gray-600">
            Assisted clinical assessments for healthcare professionals
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {/* New Assessment Card - Primary Action */}
          <button
            onClick={onNewAssessment}
            className="group bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-200 p-8 text-left border-2 border-teal-500 hover:border-teal-600"
          >
            <div className="bg-teal-100 w-16 h-16 rounded-full flex items-center justify-center mb-6 group-hover:bg-teal-200 transition-colors">
              <FileText className="text-teal-700" size={32} />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">New Assessment</h3>
            <p className="text-gray-600 mb-4">
              Start a new FIM/FAM assessment by entering clinical notes.
            </p>
            <div className="flex items-center text-teal-600 font-semibold">
              Start Now
              <svg className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </button>

          {/* My Cases Card - Secondary Action */}
          <button
            onClick={onViewCases}
            className="group bg-white rounded-lg shadow-md hover:shadow-lg transition-all duration-200 p-8 text-left border-2 border-gray-200 hover:border-blue-500"
          >
            <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mb-6 group-hover:bg-blue-200 transition-colors">
              <Users className="text-blue-700" size={32} />
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-3">My Case Load</h3>
            <p className="text-gray-600 mb-4">
              View and manage your case load with saved assessment history.
            </p>
            <div className="flex items-center text-blue-600 font-semibold">
              View Cases
              <svg className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </button>
        </div>

        {/* Quick Stats or Info Section
        <div className="mt-12 bg-white rounded-xl shadow-md p-6">
          <div className="grid md:grid-cols-3 gap-6 text-center">
            <div>
              <div className="text-3xl font-bold text-teal-600 mb-2">36</div>
              <div className="text-gray-600">Assessment Domains</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-teal-600 mb-2">AI-Powered</div>
              <div className="text-gray-600">Score Generation</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-teal-600 mb-2">1-7</div>
              <div className="text-gray-600">FIM/FAM Scale</div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default HomeScreen;

